import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { useParams } from 'react-router-dom';
import GoBack from 'components/actions/GoBack';
import { getImage } from 'variables/images';

const SellerBenchMarkPage = () => {
    const [offer, setOffer] = useState<any>({});
    const params = useParams();

    const getOffer = (id: string) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/seller-offer/marketplace/${id}`, config)
            .then((res) => {
                setOffer(res.data);
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    useEffect(() => {
        if (
            !localStorage.getItem('token') ||
            localStorage.getItem('token').length < 10
        )
            window.location.href = '/auth/sign-up';
        getOffer(params.id);
        // eslint-disable-next-line
    }, []);

    return (
        <div className="flex flex-col gap-4">
            <GoBack />

            <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
                <div className="flex gap-8">
                    <div className="flex-shrink-0">
                        {getImage(offer?.industry, offer?.subIndustry) ? (
                            <img
                                src={getImage(offer?.industry, offer?.subIndustry)}
                                className="mb-1 max-h-[400px] w-full rounded-xl object-cover"
                                alt={`${offer?.industry} ${offer?.subIndustry}`}
                            />
                        ) : (
                            <div className="flex h-[400px] w-[400px] items-center justify-center rounded-xl bg-leadrs-bg">
                                <p className="font-geist text-sm text-leadrs-text-soft">
                                    {offer?.industry} - {offer?.subIndustry}
                                </p>
                            </div>
                        )}
                    </div>

                    <div className="flex-1">
                        <p className="font-geist text-xs font-semibold uppercase tracking-widest text-leadrs-text-soft">
                            {offer?.industry}
                        </p>
                        <h1 className="mt-1 font-crimson text-3xl font-semibold text-leadrs-text">
                            {offer?.subIndustry}
                        </h1>
                        <p className="mb-4 font-geist text-sm font-semibold text-leadrs-text-soft">
                            #{offer?.offerNumber}
                        </p>

                        <div className="mb-4 h-px w-full bg-leadrs-stroke" />

                        <div className="grid grid-cols-1 gap-4">
                            <div>
                                <p className="font-geist text-xs font-bold text-leadrs-text">Quantite</p>
                                <p className="mt-1 font-geist text-sm text-leadrs-text-soft">{offer?.weeklyQuantity} leads</p>
                            </div>
                            <div>
                                <p className="font-geist text-xs font-bold text-leadrs-text">Champs de donnees</p>
                                <p className="mt-1 font-geist text-sm text-leadrs-text-soft">{offer?.fields?.join(', ')}</p>
                            </div>
                            <div>
                                <p className="font-geist text-xs font-bold text-leadrs-text">Canaux d'acquisition</p>
                                <p className="mt-1 font-geist text-sm text-leadrs-text-soft">{offer?.channels?.join(', ')}</p>
                            </div>
                            <div>
                                <p className="font-geist text-xs font-bold text-leadrs-text">Besoin</p>
                                <p className="mt-1 font-geist text-sm text-leadrs-text-soft">{offer?.type}</p>
                            </div>
                            <div>
                                <p className="font-geist text-xs font-bold text-leadrs-text">Departements</p>
                                <p className="mt-1 font-geist text-sm text-leadrs-text-soft">{offer?.regions?.join(', ')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SellerBenchMarkPage;
